import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/sjx.png'
import _imports_1 from '../../assets/image/jinbi.png'
import _imports_2 from '../../assets/image/renzhen.png'
import _imports_3 from '../../assets/image/close-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-2de4d8bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-main" }
const _hoisted_2 = { class: "index_banner" }
const _hoisted_3 = { class: "main-container" }
const _hoisted_4 = { class: "max-section section bb-adver mb-100" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title fs-40" }, "近日更新", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title-des fs-24 c9" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c0 fw-500" }, "小步快跑，稳定更新，"),
  /*#__PURE__*/_createTextVNode("新鲜滚辣烫的海外素材，一手海外高端素材触手可及")
], -1))
const _hoisted_8 = { class: "translucent flow-layout mb-100" }
const _hoisted_9 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_10 = { class: "page-title fs-40" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "max-section section mb-40 mt-70" }
const _hoisted_13 = { class: "works-item" }
const _hoisted_14 = {
  class: "img",
  style: {"aspect-ratio":"3/2"}
}
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "info" }
const _hoisted_17 = { class: "title fs-20" }
const _hoisted_18 = { class: "author" }
const _hoisted_19 = ["src", "onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sjx",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "oper" }
const _hoisted_24 = { class: "jinbi" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "fs-20 fw-500 pirce"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "¥", -1))
const _hoisted_28 = {
  key: 1,
  class: "fs-20 fw-500 pirce c-00B96B"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "renzhen" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_30 = { class: "works-item" }
const _hoisted_31 = {
  class: "img",
  style: {"aspect-ratio":"3/2"}
}
const _hoisted_32 = { class: "content" }
const _hoisted_33 = { class: "info" }
const _hoisted_34 = { class: "title fs-20" }
const _hoisted_35 = { class: "author" }
const _hoisted_36 = ["src"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sjx",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "oper" }
const _hoisted_41 = { class: "jinbi" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_43 = {
  key: 0,
  class: "fs-20 fw-500 pirce"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "¥", -1))
const _hoisted_45 = {
  key: 1,
  class: "fs-20 fw-500 pirce c-00B96B"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "renzhen" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_47 = { class: "pt-50 pb-100 tlc" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("查看更多")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title fs-40" }, "加入我们", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title-des fs-24 c9" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c0 fw-500" }, "500000+设计师已加入像素设计，"),
  /*#__PURE__*/_createTextVNode("800+海内外设计师在线为您提供优质服务")
], -1))
const _hoisted_51 = { class: "translucent designer-avatar mt-70 mb-70" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["src"]
const _hoisted_54 = {
  key: 0,
  class: "mask"
}
const _hoisted_55 = { class: "model-ad" }
const _hoisted_56 = ["src"]

import { ref, onMounted, computed } from 'vue';
import indexBanner from '@/components/home/index-banner/index.vue'
import imageView from '@/components/image-view/index.vue'
import infiniteScroll from "@/components/infiniteScroll/index.vue"
import request from "../../utils/request";
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
// 获取广告
const bannerArr = ref<any[]>([])
request.get("/home/getAdvList", { type: 6 }).then((res: any) => {
  bannerArr.value = res.result
})
const fourAgArr = ref<any[]>([])
request.get("/home/getAdvList", { type: 2 }).then((res: any) => {
  fourAgArr.value = res.result
})

// 首页弹框
const modelAgArr = ref<any[]>([])
const modelAgShow = ref<Boolean>(false)
request.get("/home/getAdvList", { type: 4 }).then((res: any) => {
  if (res && res.code == 200) {
    modelAgArr.value = res.result
    if (res.result && res.result.length > 0) {
      modelAgShow.value = true
    }
  }
})
const isClosedToday = ref(false);

const checkAdvertisementStatus = () => {
  const currentDate = new Date().toLocaleDateString();
  const closedToday = localStorage.getItem('advertisementClosedOn') === currentDate;
  isClosedToday.value = !closedToday;
};
const closeAdvertisement = () => {
  modelAgShow.value = false
  const currentDate = new Date().toLocaleDateString();
  localStorage.setItem('advertisementClosedOn', currentDate);
  isClosedToday.value = false;
};
// 近日更新列表
let recentrr = ref<any[]>([])
const recentLoading = ref<Boolean>(false)
const getRecentList = () => {
  recentLoading.value = true
  request.get("/home/getBaseItemInfoListRecently").then((res: any) => {
    if (res && res.code == 200) {
      recentrr.value = res.result
    }
    recentLoading.value = false
  })
}
getRecentList()
// 商品配置
const allProductArr = ref<any[]>([])
request.get("/home/getHomeItemConfig").then((res: any) => {
  allProductArr.value = res.result
})
// 初始显示数量
const initialDisplayCount = 3;
// 当前显示数量
const displayCount = ref(initialDisplayCount);

// 计算当前应显示的项目
const displayedItems = computed(() => {
  return allProductArr.value.slice(0, displayCount.value);
});
// 是否展开状态
const isExpanded = computed(() => {
  return displayCount.value > initialDisplayCount;
});

// 切换显示状态
const toggleDisplay = () => {
  if (isExpanded.value) {
    // 如果已展开，则收起
    displayCount.value = initialDisplayCount;
  } else {
    // 显示更多，增加显示数量，或者全部显示
    displayCount.value += initialDisplayCount;
    if (displayCount.value >= allProductArr.value.length) {
      displayCount.value = allProductArr.value.length; // 防止超出
    }
  }
};
// 加入我们
const avatarArr = ref<any[]>([])
request.get("/home/getJoinUserList").then((res: any) => {
  avatarArr.value = res.result
})
//作品近日更新列表
// request.get("/home/getBaseItemInfoListRecently").then((res: any) => {
// })

const highlightedText = (text:any,highlightText:any) => {
  if (!highlightText) return text; // 如果没有指定高亮文本，返回原始文本
  const regex = new RegExp(`(${highlightText})`, 'gi');
  return text.replace(regex, `<span class='c0 fw-500'>$1</span>`);
}

const goPage = (url: any, query: any) => {
  router.push({
    path: url,
    query: query
  })
}
const goAd = (url: any) => {
  window.open(url)
}
onMounted(() => {
  checkAdvertisementStatus();
});

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(indexBanner, { bannerArr: bannerArr.value }, null, 8, ["bannerArr"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_row, { gutter: { xs: 10, sm: 20, lg: 30 } }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fourAgArr.value, (item) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                xs: { span: 12 },
                lg: { span: 6 }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(imageView, {
                      src: item.pictureUrl,
                      href: item.linkUrl
                    }, null, 8, ["src", "href"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        })
      ]),
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_spin, { spinning: recentLoading.value }, {
          default: _withCtx(() => [
            (recentLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true),
            _createVNode(infiniteScroll, { imageList: _unref(recentrr) }, null, 8, ["imageList"])
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allProductArr.value, (item) => {
        return (_openBlock(), _createElementBlock("blockquote", null, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1),
          (item.subTitle)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "page-title-des fs-24 c9",
                innerHTML: highlightedText(JSON.parse(item.subTitle).key,JSON.parse(item.subTitle).highlight)
              }, null, 8, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_a_row, {
              gutter: [{ xs: 10, lg: 40 }, { xs: 10, lg: 40 }],
              class: "mb-40"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.baseItemInfoList, (pro, index) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_a_col, {
                    xs: { span: 24 },
                    lg: { span: 12 }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(imageView, {
                            style: {"height":"100%"},
                            src: pro.coverUrls,
                            id: pro.id
                          }, null, 8, ["src", "id"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(pro.name), 1),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("img", {
                                class: "author-photo pointer",
                                src: pro.baseUserInfo.avatar,
                                alt: "",
                                onClick: ($event: any) => (goPage('/stylist', { id: pro.baseUserInfo.id }))
                              }, null, 8, _hoisted_19),
                              _createElementVNode("span", {
                                class: "name fs-14 c9",
                                onClick: ($event: any) => (goPage('/stylist', { id: pro.baseUserInfo.id }))
                              }, _toDisplayString(pro.baseUserInfo.realname), 9, _hoisted_20),
                              _hoisted_21,
                              _createElementVNode("span", {
                                class: "fs-14 ml-10 type-name",
                                onClick: ($event: any) => (goPage('/filtering', { id: pro.itemCategoryInfo.id, pid: item.categoryId }))
                              }, _toDisplayString(pro.itemCategoryInfo.name), 9, _hoisted_22)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              (pro.isFree === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    _hoisted_27,
                                    _createTextVNode(_toDisplayString(pro.price), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_28, "免费"))
                            ]),
                            _hoisted_29
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1536)), [
                    [_vShow, index < 2]
                  ])
                }), 256))
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_row, { gutter: [{ xs: 10, lg: 40 }, { xs: 10, lg: 40 }] }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.baseItemInfoList, (pro, index) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_a_col, {
                    xs: { span: 12 },
                    lg: { span: 6 }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(imageView, {
                            style: {"height":"100%"},
                            src: pro.coverUrls,
                            id: pro.id
                          }, null, 8, ["src", "id"])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, _toDisplayString(pro.name), 1),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("img", {
                                class: "author-photo",
                                src: pro.baseUserInfo.avatar,
                                alt: ""
                              }, null, 8, _hoisted_36),
                              _createElementVNode("span", {
                                class: "name fs-14 c9",
                                onClick: ($event: any) => (goPage('/stylist', { id: pro.baseUserInfo.id }))
                              }, _toDisplayString(pro.baseUserInfo.realname), 9, _hoisted_37),
                              _hoisted_38,
                              _createElementVNode("span", {
                                class: "fs-14 ml-10 type-name",
                                onClick: ($event: any) => (goPage('/filtering', { id: pro.itemCategoryInfo.id, pid: item.categoryId }))
                              }, _toDisplayString(pro.itemCategoryInfo.name), 9, _hoisted_39)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              (pro.isFree === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                    _hoisted_44,
                                    _createTextVNode(_toDisplayString(pro.price), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_45, "免费"))
                            ]),
                            _hoisted_46
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1536)), [
                    [_vShow, index > 1]
                  ])
                }), 256))
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (goPage('/filtering', { pid: item.categoryId }))
            }, {
              default: _withCtx(() => [
                _hoisted_48
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]))
      }), 256)),
      _hoisted_49,
      _hoisted_50,
      _createElementVNode("div", _hoisted_51, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(avatarArr.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: ($event: any) => (goPage('/stylist', { id: item.id }))
          }, [
            _createElementVNode("img", {
              src: item.avatar,
              alt: ""
            }, null, 8, _hoisted_53)
          ], 8, _hoisted_52))
        }), 128))
      ])
    ]),
    (modelAgShow.value && isClosedToday.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("img", {
              class: "close",
              src: _imports_3,
              alt: "",
              onClick: closeAdvertisement
            }),
            _createElementVNode("img", {
              class: "ad-img",
              src: modelAgArr.value[0].pictureUrl,
              alt: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goAd(modelAgArr.value[0].linkUrl)))
            }, null, 8, _hoisted_56)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})